<template>
    <div>       
            <br>
            <!--Datos para la emision-->
        <b-card>
            <div slot="header">
                <b-row align-v="center">
                    <b-col cols="2"><datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker></b-col>
                    <b-col cols="8">
                        <h3 class="text-center">Factura de Viaje</h3> 
                    </b-col>
                    <b-col cols="2">
                        <b-row align-v="center">
                            <b-col cols="4" class="text-right">
                                <label>Moneda</label>
                            </b-col>
                            <b-col cols="8">
                                <select class="custom-select mr-sm-2" v-model="tipodemoneda">
                                        <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                            {{ moneda.descripcion }}
                                        </option>
                                </select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>                
            </div>
            <div class="row">
                <div class="col-md-10">        
                    <b-row>                       
                        <b-col sm="2">
                             <b-input-group>
                                <b-form-input placeholder="RUC" maxlength="11" v-model="receptor.numero" @change="getReceivers"></b-form-input>
                             </b-input-group>
                             <template v-if="cargandoreceptor">
                                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                             </template>
                             <b-list-group v-if="listarec" class="searcher-field">
                                <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item>                                 
                                <template v-for="(item, index) in listaReceptores">
                                    <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                                </template>
                             </b-list-group>                            
                        </b-col>
                        <b-col sm="4"><b-form-input size="md" type="text" :value="receptor.razonSocial" readonly="" placeholder="Razón Social"></b-form-input></b-col>
                        <b-col sm="6"><b-form-input size="md" type="text" :value="receptor.direccionReferencia" readonly="" placeholder="Dirección"></b-form-input></b-col>   
                    </b-row>
                </div>
                <div class="col-md-2">
                    <div class="row">                        
                        <div class="col-md-12">
                            <b-row>
                                <template>
                                    <b-col> 
                                        <b-input-group>
                                            <template v-if="seriesCargadas">
                                                <b-button size="md" variant="secondary" outline-success>
                                                    Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                                                </b-button>
                                            </template>
                                            <template v-else>
                                                <select class="form-control input-placedark input-dark" v-model="indexSerie">
                                                    <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                                                </select>
                                            </template>
                                        </b-input-group>
                                    </b-col>
                                </template>                                                   
                            </b-row>                           
                        </div>
                    </div>
                </div>
            </div>
            <hr>        
            <div class="row">             
                <div class="col-sm-2 form-group">
                    <input v-if="!vunitario" type="number" min="0.0" step="0.01" v-model="precioVentaUnitario" class="form-control input-requerido" placeholder="Precio Unitario (con IGV)" required>
                    <input v-else type="number" min="0.0" step="0.01" v-model="precioVentaUnitario" class="form-control" placeholder="Precio Unitario (con IGV)" required disabled>
                    <small v-if="checkprecioventaunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckprecioventaunitario }}</span></small> 
                </div>
                <div class="col-sm-2 form-group">
                    <input v-if="vunitario" type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control" placeholder="Valor Unitario (Sin IGV)" required>
                    <input v-else type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control" placeholder="Valor Unitario (Sin IGV)" required disabled>
                    <small v-if="checkvalorunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckvalorunitario }}</span></small> 
                </div>
                <div class="col-sm-2 form-group">
                    <select class="custom-select mr-sm-2" v-model="especificacionIgv" disabled>
                        <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                            {{ afec.descripcion }}
                        </option>
                    </select>
                    
                </div>
                <div class="col-sm-2 form-group">
                    <select class="custom-select mr-sm-2" v-model="especificacion" disabled>
                        <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                            {{ espec.descripcion }}
                        </option>
                    </select>
    
                </div>
                <div class="col-sm-4 form-group">
                    <input type="text" class="form-control input-requerido" maxlength="250" v-model="descripcion" placeholder="Descripcion (*)">
                    <small v-if="checkdescripcion" class="form-text text-muted"><span class="text-danger">{{ responsecheckdescripcion }}</span></small>
                </div>
            </div>
           <!--Items Boleto-->
            <div class="row">
                <div class="col-md-12">
                    <b-alert show>
                       <b-row>
                           <div class="col-sm-1 form-group">
                                 <select class="custom-select mr-sm-2" id="inlineFormCustomSelect" v-model="tipoDocumentoPasajero">                       
                                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select> 
                            </div>
                           <b-col sm="2">
                                <b-input-group>
                                    <b-form-input placeholder="Buscar..." v-model="numeroDocumentoPasajero" @change="getReceiversViajante"></b-form-input>
                                    <b-input-group-text slot="append">
                                        <button class="btn btn-warning btn-sm sinresultados" @click="enableFieldsReceptor"><i class="fa fa-plus"></i></button>
                                    </b-input-group-text>
                                </b-input-group>
                                <template v-if="cargandoreceptorViajante">
                                        <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                                </template>
                                <b-list-group v-if="listarecViajante" class="searcher-field">
                                    <b-list-group-item v-if="norecViajante">No hay Receptores con ese número</b-list-group-item>                                 
                                    <template v-for="(item, index) in listaViajantes">
                                        <b-list-group-item :key="index" @click="setReceiverViajante(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                                    </template>
                                </b-list-group>                                   
                            </b-col>
                            <b-col sm="3"><b-form-input size="md" type="text" v-model="nombresApellidosPasajero" :value="nombresApellidosPasajero" placeholder="Nombre de Viajero"></b-form-input></b-col>
                            <div class="col-sm-2 form-group">
                                <datetime 
                                    placeholder="Selecciona Fecha"
                                    type="date"
                                    v-model="fechaInicioProgramado">
                                </datetime>
                                <!-- <datepicker :language="es" v-model="fechaInicioProgramado" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha de Viaje"></datepicker> -->
                            </div>
                            <div class="col-sm-2 form-group">
                                <datetime      
                                    placeholder="Selecciona Hora"
                                    type="time"
                                    v-model="horaInicioProgramado">
                                </datetime>
                            </div>
                            <div class="col-sm-1 form-group">
                                <b-form-input
                                    v-model="numeroAsiento"
                                    type="text"
                                    placeholder="Nro. Asiento">
                                </b-form-input>
                            </div>
                             <div class="col-sm-1 form-group">
                                <b-form-input
                                    v-model="informacionManifiesto"
                                    type="text"
                                    placeholder="Manifiesto">
                                </b-form-input>
                            </div>
                       </b-row>
                       <b-row>
                           <div class="col-md-6">
                                <div class="row">
                                    <b-col cols="2">
                                        <b-form-input
                                            class="input-requerido"
                                            type="text"
                                            v-model="ubigeoPartida"
                                            required
                                            :placeholder="placeholderUbigeoPartida">
                                        </b-form-input>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-btn  @click="modalUbigeoPartida=true"><i class="fa fa-plane"> Selecciona</i></b-btn>
                                        <b-modal v-model="modalUbigeoPartida" title="Ubigeo de Partida" size="lg">
                                            <b-row>
                                                <b-col cols="4">
                                                    <template>
                                                        <h5> Selecciona Departamento </h5>
                                                        <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoOrigen">
                                                            <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                                                        </select>
                                                    </template>
                                                </b-col>
                                                <b-col cols="4">
                                                    <template>
                                                        <h5> Selecciona Provincia </h5>
                                                        <div v-if="!provOrigen">
                                                            <b-form-input 
                                                                type="text"
                                                                disabled
                                                                placeholder="Selecciona un Departamento...">
                                                            </b-form-input>
                                                        </div>
                                                        <div v-else-if="provOrigenCargando">
                                                            Cargando <i class="fa fa-spin fa-spinner"></i>
                                                        </div>
                                                        <div v-else>
                                                            <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoOrigen">
                                                                <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </template>
                                                </b-col>
                                                <b-col cols="4">
                                                    <template>
                                                        <h5> Selecciona Distrito </h5>
                                                        <div v-if="!distOrigen">
                                                            <b-form-input 
                                                                type="text"
                                                                disabled
                                                                placeholder="Selecciona una Provincia...">
                                                            </b-form-input>
                                                        </div>
                                                        <div v-else-if="distOrigenCargando">
                                                        Cargando <i class="fa fa-spin fa-spinner"></i>
                                                        </div>
                                                        <div v-else>
                                                            <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoOrigen">
                                                                <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </template>
                                                </b-col>
                                            </b-row>
                                        </b-modal>
                                    </b-col>
                                    <b-col cols="8">
                                        <b-input-group size="md" :prepend="prependUbigeoOrigen">
                                            <b-form-input 
                                                class="input-requerido"
                                                type="text"
                                                v-model="direccionPartida"
                                                required
                                                placeholder="Dirección de Partida">
                                            </b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <b-col cols="2">
                                        <b-form-input
                                            class="input-requerido"
                                            type="text"
                                            v-model="ubigeoLlegada"
                                            required
                                            :placeholder="placeholderUbigeoLlegada">
                                        </b-form-input>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-btn @click="modalUbigeoDestino=true"><i class="fa fa-plane"> Selecciona</i></b-btn>
                                        <b-modal v-model="modalUbigeoDestino" title="Ubigeo de Llegada" size="lg">
                                            <b-row>
                                                <b-col cols="4">
                                                    <template>
                                                        <h5> Selecciona Departamento </h5>
                                                        <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoDestino">
                                                            <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                                                        </select>
                                                    </template>
                                                </b-col>
                                                <b-col cols="4">
                                                    <template>
                                                        <h5> Selecciona Provincia </h5>
                                                        <div v-if="!provDestino">
                                                            <b-form-input 
                                                                type="text"
                                                                disabled
                                                                placeholder="Selecciona un Departamento...">
                                                            </b-form-input>
                                                        </div>
                                                        <div v-else-if="provDestinoCargando">
                                                            Cargando <i class="fa fa-spin fa-spinner"></i>
                                                        </div>
                                                        <div v-else>
                                                            <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoDestino">
                                                                <option v-for="provincia in listProvinceDestino.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </template>
                                                </b-col>
                                                <b-col cols="4">
                                                    <template>
                                                        <h5> Selecciona Distrito </h5>
                                                        <div v-if="!distDestino">
                                                            <b-form-input 
                                                                type="text"
                                                                disabled
                                                                placeholder="Selecciona un Departamento...">
                                                            </b-form-input>
                                                        </div>
                                                        <div v-else-if="distDestinoCargando">
                                                            Cargando <i class="fa fa-spin fa-spinner"></i>
                                                        </div>
                                                        <div v-else>
                                                            <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoDestino">
                                                                <option v-for="distrito in listDistrictDestino.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </template>
                                                </b-col>
                                            </b-row>
                                        </b-modal>
                                    </b-col>
                                    <b-col cols="8">
                                        <b-input-group size="md" :prepend="prependUbigeoDestino">
                                            <b-form-input
                                                class="input-requerido"
                                                type="text"
                                                v-model="direccionLlegada"
                                                required
                                                placeholder="Dirección de Llegada">
                                            </b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </div>
                            </div>
                       </b-row>
                        
                    </b-alert>
                </div>
            </div>
            <!--Fin de Items Boleto-->
            <div class="row text-center">
                <div class="col-md-12">
                    <button class="btn btn-primary btnagregarstyle" v-if="validateFields()" @click="addItem"><i class="fa fa-plus"></i> Agregar</button>
                    <button class="btn btn-secondary btnagregarstyle" disabled v-else><i class="fa fa-plus"></i> Agregar</button>
                </div> 
            </div>
            <br>

            <table class="table table-bordered table-sm">
                <thead class="thead-light">
                    <tr>
                        <th Width=10%>Cantidad</th>
                        <th Width=50%>Descripcion</th>
                        <th Width=10%>{{ itemTitleSubtotal }}</th>
                        <th Width=10%>Igv</th>
                        <th Width=10%>{{ itemTitleTotal }}</th>
                        <th Width=10%>Acciones</th>
                    </tr>
                </thead>
            </table>
            <table class="table table-borderless table-sm">
                <tbody v-for="(item, index) in items" :key="index">
                    <tr>
                        <td Width=10%>{{ item.cantidad }}</td>
                        <td Width=50%>{{ item.descripcion }}</td>
                        <td Width=10%>{{ item.valorUnitario }}</td>
                        <td Width=10%>{{ item.montoAfectacionIgv }}</td>
                        <td Width=10%>{{ item.valorVenta }}</td>
                        <td Width=10%>                            
                            <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(index)"><i class="fa fa-trash danger"></i></button>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>Numero de Asiento: </td>
                        <td colspan="2">{{ item.adicional.transporteTerrestrePasajeros.numeroAsiento }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>Documento Pasajero: </td>
                        <td colspan="2">{{ item.adicional.transporteTerrestrePasajeros.numeroDocumentoPasajero }}</td>
                    </tr>
                     <tr>
                        <td></td>
                        <td></td>
                        <td>Nombre y apellidos: </td>
                        <td colspan="2">{{ item.adicional.transporteTerrestrePasajeros.nombresApellidosPasajero }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>Lugar de origen: </td>
                        <td colspan="2">{{ item.adicional.transporteTerrestrePasajeros.direccionDetalladaOrigen }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>Lugar de destino: </td>
                        <td colspan="2">{{ item.adicional.transporteTerrestrePasajeros.direccionDetalladaDestino }}</td>
                    </tr>
                </tbody>
            </table>
            <hr>
        <div class="row">
            <div class="col-md-8">
                 <div>
                    <b-btn block v-b-toggle.extras class="m-1 colorestelemovil">Extras</b-btn>
                    <b-collapse id="extras">
                        <b-card>
                            <div class="row">
                                <div class="col-sm-3 form-group">
                                    <select class="custom-select mr-sm-2" v-model="formadepago">
                                        <option :value="fpago.codigo" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                            {{ fpago.nombre }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-sm-3 form-group">
                                    <b-form-group
                                        label-for="input_seriedeguia"
                                        :invalid-feedback="invalidFeedbackOrdenCompra"
                                        :valid-feedback="validFeedbackOrdenCompra"
                                        :state="stateOrdenCompra">
                                        <b-input-group size="md">
                                            <b-form-input :value="ordenCompra" 
                                                required 
                                                @input="ordenCompra = $event.toUpperCase()" 
                                                v-model="ordenCompra" 
                                                maxlength="20" 
                                                class="form-control" 
                                                type="text" 
                                                id="input_ordendecompra" 
                                                :state="stateOrdenCompra" 
                                                placeholder="Orden de Compra">
                                            </b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-3 form group">
                                    <datepicker v-model="fvencimiento" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha de Vencimiento"></datepicker>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
                <div>
                    <b-btn block v-b-toggle.relacionadas class="m-1 colorestelemovil">Guias Relacionadas</b-btn>
                    <b-collapse id="relacionadas">
                        <b-card>
                            <div class="row">
                                <div class="col-sm-2 form-group">
                                    <b-form-group
                                        label-for="input_seriedeguia"
                                        :invalid-feedback="invalidFeedbackSerieGuia"
                                        :valid-feedback="validFeedbackSerieGuia"
                                        :state="stateSerieGuia">
                                        <b-input-group size="md">
                                            <b-form-input :value="seriedeguia" 
                                                required @input="seriedeguia = $event.toUpperCase()" 
                                                v-model="seriedeguia" 
                                                minlength="4" 
                                                maxlength="4" 
                                                class="form-control" 
                                                type="text" 
                                                id="input_seriedeguia" 
                                                :state="stateSerieGuia" 
                                                placeholder="Serie">
                                            </b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-2 form-group">
                                    <input v-model="numerodeguia" type="number" class="form-control" placeholder="Numero" required>  
                                </div>
                                <div class="col-sm-6 form-group">
                                    <select class="custom-select mr-sm-2" v-model="tipodeguia">
                                        <option :value="tipo.codigo" v-for="tipo in tiposGuia" v-bind:key="tipo.codigo">
                                            {{ tipo.nombre }}
                                        </option>
                                    </select>
                                </div>
                                 <div class="col-sm-2">
                                    <button v-if="validateFieldsGuia()" class="btn btn-primary" @click="addGuia"><i class="fa fa-plus"></i> Agregar</button>
                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                </div>
                            </div>
                            <div class="row">
                                <b-table striped hover :items="items_guias" :fields="fields_guias">
                                    <template striped hover slot="acciones" slot-scope="guiasRelacionadas">
                                        <b-button-group>
                                            <b-button title="Eliminar Guia" @click="deleteGuia(item)"><i class="fa fa-trash"></i></b-button>
                                        </b-button-group>
                                    </template>
                                </b-table>
                            </div>
                        </b-card>
                        
                    </b-collapse>
                </div>
                <div>
                    <b-btn block v-b-toggle.adicionales class="m-1 colorestelemovil">Datos Adicionales</b-btn>
                    <b-collapse id="adicionales">
                        <b-card>
                            <div class="row">
                                <div class="col-sm-5 form-group">
                                    <input type="text" placeholder="Nombre del Adicional" class="form-control" v-model="clave">
                                </div>
                                <div class="col-sm-5 form-group">
                                    <input type="text" placeholder="Valor del Adicional" class="form-control" v-model="valor">
                                </div>
                                <div class="col-sm-2">
                                    <button v-if="validateFieldsAdicionales()" class="btn btn-primary" @click="addAdicional"><i class="fa fa-plus"></i> Agregar</button>
                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                </div>
                            </div>
                            <div class="row">
                                <b-table striped hover :items="items_adicionales" :fields="fields_adicionales">
                                    <template striped hover slot="acciones" slot-scope="items_adicionales">
                                        <b-button-group>
                                            <b-button title="Eliminar Adicional" @click="deleteAdicional(item)"><i class="fa fa-trash"></i></b-button>
                                        </b-button-group>
                                    </template>
                                </b-table>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
            <div class="col-md-4">
                <div class="row">
                    <div class="col-md-6">
                        <div><strong>Total IGV:</strong></div>
                        <div><strong>Total Venta Gravada:</strong></div>
                        <div><strong>Total Venta Exonerada:</strong></div>
                        <div><strong>Total Venta Inafecta:</strong></div>
                        <div><strong>Total Venta:</strong></div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            {{ moneda.simbolo }} {{ accumulateIgv() }}
                        </div>
                        <div>
                            {{ moneda.simbolo }} {{ accumulateRecordedSale() }}
                        </div>
                        <div>
                            {{ moneda.simbolo }} {{ accumulateExoneratedSale() }}
                        </div>
                        <div>
                            {{ moneda.simbolo }} {{ accumulateUnaffectedSale() }}
                        </div>
                        <div>
                            {{ moneda.simbolo }} {{ accumulateTotalSale() }}
                        </div>
                    </div>
                </div>

                <template v-if="accumulateTotalSale() >= 700">
                    <b-alert show variant="info">
                    <b-row>
                        <b-col cols="12">
                            Servicio de Transporte de Pasajeros -- 10% 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">Cuenta de Detracciones: </b-col>
                        <b-col cols="6">
                        <template v-if="cuentaDetracionAdmin != ''">
                            <b-col cols="12">
                            <template v-if="cuentaDetracionAdmin != ''">
                                {{ cuentaDetracionAdmin }}
                            </template>
                            <template v-else>
                                No existe cuenta de detracción, registrelo en Administrador/Perfil
                            </template>
                            </b-col>
                        </template>
                        <template v-else>
                            Cargando <i class="fa fa-spin fa-spinner"></i>
                        </template>
                        </b-col>
                    </b-row>
                    </b-alert>
                </template>
             
                <br>
                <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-4">
                        <template v-if="validateInvoice()">
                            <button v-if="!cargandoemision" class="btn btn-primary" @click.prevent="sendInvoice"><i class="fa fa-location-arrow"></i> Emitir</button>
                            <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Emitir</button>
                        </template>
                        <template v-else>
                            <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Emitir</button>
                        </template>
                    </div>
                     <!-- <b-btn v-b-modal.modal1><i class="fa fa-eye"></i></b-btn>
                     <b-modal id="modal1" title="Factura" size="lg">
                        <p class="my-4">{{ invoice }}</p>
                    </b-modal> -->
                </div>        
       
            </div>  
        </div>
        <vue-snotify></vue-snotify>
        </b-card>           
    </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { Datetime } from 'vue-datetime'
import vSelect  from 'vue-select'
import { DocumentosViajero } from '@/shared/utils'
import { Departamentos } from '@/shared/utils'

export default {
    name: 'FacturaBoleto',
    components: {
        Datepicker,
        vSelect,
        datetime: Datetime
    },
    data: () => {
        return {
            cuentaDetracionAdmin: '',
            detraccion: {
                codigo: '000',
                descripcion: 'Seleccionar tipo detraccion',
                porcentajeDetraccion: '0%'
            },
            tipodoc: '1',
            indexSerie: 0,
            seriesCargadas: true,
            newSerie: true,
            rolSeries: '',
            listaSeries: [],
            listDepartamento: Departamentos,
            modalUbigeoDestino: false,
            modalUbigeoPartida: false,
            distDestino: false,
            distDestinoCargando: false,
            provDestino: false,
            provDestinoCargando: false,
            provOrigen: false,
            provOrigenCargando: false,
            distOrigen: false,
            distOrigenCargando:  false,
            prependUbigeoOrigen: '',
            prependUbigeoDestino: '',
            placeholderUbigeoPartida: 'Ubigeo Part.',
            placeholderUbigeoLlegada: 'Ubigeo LLeg.',
            departamentoSeleccionadoUbigeoOrigen: '',
            provinciaSeleccionadaUbigeoOrigen: '',
            distritoSeleccionadoUbigeoOrigen: '',
            departamentoSeleccionadoUbigeoDestino: '',
            provinciaSeleccionadaUbigeoDestino: '',
            distritoSeleccionadoUbigeoDestino: '',
            listDepartmentOrigen: [],
            listProvinceOrigen: [],
            listDistrictOrigen: [],
            listDepartmentDestino: [],
            listProvinceDestino: [],
            listDistrictDestino: [],
            ubigeoPartida: '',
            direccionPartida: '',
            ubigeoLlegada: '',
            direccionLlegada: '',
            date: '',
            descripcion: '',
            item: {
                baseAfectacionIgv: '',
                valorVenta: '',
                tipoAfectacionIgv: '',
                montoTotalImpuestosItem: '', 
                codigoTributo: '',
                unidadMedidaCantidad: '',
                cantidad: '',
                descripcion: '',
                valorUnitario: '', 
                tipoPrecioVentaUnitario: '',
                tipoPrecioVentaUnitario: '',
                montoAfectacionIgv: '',
                porcentajeImpuesto: '',
                precioVentaUnitario: '', 
                valorVenta: '', 
                adicional: {
                    transporteTerrestrePasajeros: {
                        numeroAsiento: '',
                        informacionManifiesto: '',
                        numeroDocumentoPasajero: '',
                        tipoDocumentoPasajero: 1,
                        nombresApellidosPasajero: '',
                        ubigeoLugarDestino: '',
                        direccionDetalladaDestino: '',
                        ubigeoLugarOrigen: '',
                        direccionDetalladaOrigen: '',
                        fechaInicioProgramado: '',
                        horaInicioProgramado: ''
                    }
                }
            },
            documentosIdentidad: DocumentosViajero,
            transporteTerrestrePasajeros: [],
            numeroAsiento: '',
            informacionManifiesto: '',
            numeroDocumentoPasajero: '',
            tipoDocumentoPasajero: 1,
            nombresApellidosPasajero: '',
            ubigeoLugarDestino: '',
            direccionDetalladaDestino: '',
            ubigeoLugarOrigen: '',
            direccionDetalladaOrigen: '',
            fechaInicioProgramado: '',
            horaInicioProgramado: '',
            previacorreo: false,
            sendcorreo: false,
            cargandoreceptor: false,
            cargandoreceptorViajante: false,
            listarec: true,
            norec: false,
            listarecViajante: true,
            norecViajante: false,
            invoice: {
                tipoOperacion: '',
                serie: '',
                montoTotalImpuestos: 0.00,
                totalVentaGravada: 0.00,
                totalVentaExonerada: 0.00,
                sumatoriaIgv: 0.00,
                importeTotal: 0.00,
                adicional: {
                    detraccion: {
                        codigoSujetoDetraccion: '',
                        numeroCuentaBanco: '',
                        medioPago: '',
                        montoDetraccion: '',
                        porcentajeDetraccion: ''
                    },
                    tipo_igv:''
                },
                guiasRelacionada: [],
                items: [
                    {
                        codigoProductoSunat: '',
                        adicional: {
                            transporteTerrestrePasajeros: {}
                        }
                    }
                ],
                receptor: {
                    tipo: '6',
                    nro: ''
                }
            },
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            largeModal: false,
            tipoOperacion: '1003',
            serie: '',
            seriecon: '',
            montoTotalImpuestos: 0.00,
            totalVentaInafecta: 0.00,
            totalVentaExonerada: 0.00,
            totalVentaGravada: 0.00,
            sumatoriaIgv: 0.00,
            importeTotal: 0.00,
            Especificacion: [],
            especificacionIgv: '02',
            adicional: {
                serieGuia: '',
                numeroGuia: '',
                tipoGuia: '',
                fechaVencimiento: '',
                codigoSunatEstablecimiento: 'A000'
            },  
            receptor: {
                numero:'',
                tipo:'',
                direccion:'',
                nombre:''                               
            },
            unidadMedidaCantidad: 'ZZ',
            tipoAfectacionIgv: '01',
            cantidad: '1',
            precioVentaUnitario: '',
            valorUnitario: '',
            flagPrecio: false,
            flagValor: false,
            flagCantidad: false,
            flagDescripcion: false,
            tipoIgv: '01',
            vunitario: false,
            servicio: false,
            ventaGratuita: false,
            descuento: false,
            cargando: false,
            cargandopdf: false,
            cargandopdf2: false,
            cargandocdr: false,
            itemValid: false,
            tipoAfecIgv: false,
            items: [],            
            emisor: {
               ruc: '',
               razonSocial: '',
               serie: '',    
            },
            cliente: {
                ruc: '',
                razonSocial: ''
            },
            ruc: '',
            listaReceptores: [],
            listaViajantes: [],
            es: es,
            // Variables para armar el JSON 
            adicionales: [],
            nombre: '',
            valor: '',
            total: '',
            editarbtn: true,
            eliminarbtn: false,
            invoices: [],
            invoices_fields: [
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'moneda', label: 'Total Gravado', sorteable: true},
                {key: 'estado', label: 'Estado', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            pactual: 1,
            limite: 10,
            orden: 'desc',
            total: 0,
            correos: '',
            pdfobject: '',
            recipients: '',
            desde: '',
            hasta: '',
            cargandoemision: false,
            cargandoadicionales: true,
            cargandorelacionadas: true,
            femision: '',
            fvencimiento: '',
            items_guias: [],
            fields_guias: [ 
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'tipodeguiadescripcion', label: 'Tipo', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true}    
            ],
            items_adicionales: [],
            fields_adicionales: [
                {key: 'clave', label: 'Clave', sorteable: true},
                {key: 'valor', label: 'Valor', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},   
            ],
            clave: '',
            valor: '',
            cargandoadicional: false,
            striped: false,
            small: false,
            add_update_item: true,
            info: null,
            listadeoperaciones: [
                {
                    tipo: "0101",
                    name: "Venta interna"
                },
                {
                    tipo: '0112',
                    name: 'Venta Interna - Sustenta Gastos Deducibles Persona Natural'
                },
                {
                    tipo: '0113',
                    name: 'Venta Interna-NRUS'
                },
                /*{
                    tipo: '0200',
                    name: 'Exportación de Bienes'
                },
                {
                    tipo: '0201',
                    name: 'Exportación de Servicios – Prestación servicios realizados íntegramente en el país'
                },
                {
                    tipo: '0202',
                    name: 'Exportación de Servicios – Prestación de servicios de hospedaje No Domiciliado'
                },
                {
                    tipo: '0203',
                    name: 'Exportación de Servicios – Transporte de navieras'
                },
                {
                    tipo: '0204',
                    name: 'Exportación de Servicios – Servicios  a naves y aeronaves de bandera extranjera'
                },
                {
                    tipo: '0205',
                    name: 'Exportación de Servicios  - Servicios que conformen un Paquete Turístico'
                },
                {
                    tipo: '0206',
                    name: 'Exportación de Servicios – Servicios complementarios al transporte de carga'
                },
                {
                    tipo: '0207',
                    name: 'Exportación de Servicios – Suministro de energía eléctrica a favor de sujetos domiciliados en ZED'
                },
                {
                    tipo: '0208',
                    name: 'Exportación de Servicios – Prestación servicios realizados parcialmente en el extranjero'
                },
                {
                    tipo: '0301',
                    name: 'Operaciones con Carta de porte aéreo (emitidas en el ámbito nacional)'
                },
                {
                    tipo: '0302',
                    name: 'Operaciones de Transporte ferroviario de pasajeros'
                },
                {
                    tipo: '0303',
                    name: 'Operaciones de Pago de regalía petrolera'
                },
                {
                    tipo: '0401',
                    name: 'Ventas no domiciliados que no califican como exportación'
                },*/
                // {
                //     tipo: '1001',
                //     name: 'Operación Sujeta a Detracción'
                // },
                /*{
                    tipo: '1002',
                    name: 'Operación Sujeta a Detracción- Recursos Hidrobiológicos'
                },*/
                // {
                //     tipo: '1003',
                //     name: 'Operación Sujeta a Detracción- Servicios de Transporte Pasajeros'
                // },
                /*{
                    tipo: '1004',
                    name: 'Operación Sujeta a Detracción- Servicios de Transporte Carga'
                },
                {
                    tipo: '2001',
                    name: 'Operación Sujeta a Percepción'
                }*/ 
            ],
            formaPago: [
            {
                codigo: '000',
                nombre: 'Elige Forma de Pago'
            },
            {
                codigo: '001',
                nombre: 'Depósito en cuenta'
            },
            {
                codigo: '002',
                nombre: 'Giro'
            },
            {
                codigo: '003',
                nombre: 'Transferencia de fondos'
            },
            {
                codigo: '004',
                nombre: 'Orden de pago'
            },
            {
                codigo: '005',
                nombre: 'Tarjeta de débito'
            },
            {
                codigo: '006',
                nombre: 'Tarjeta de crédito emitida en el país por una empresa del sistema financiero '
            },
            {
                codigo: '007',
                nombre: 'Cheques con la cláusula de "NO NEGOCIABLE", "INTRANSFERIBLES", "NO A LA ORDEN" u otra equivalente.'
            },
            {
                codigo: '008',
                nombre: 'Efectivo, por operaciones en las que no existe obligación de utilizar medio de pago'
            },
            {
                codigo: '009',
                nombre: 'Efectivo, en los demás casos'
            },
            {
                codigo: '010',
                nombre: 'Medios de pago usados en comercio exterior'
            },
            {
                codigo: '011',
                nombre: 'Documentos emitidos por las EDPYMES y las cooperativas de ahorro y crédito no autorizadas a captar depósitos del público'
            },
            {
                codigo: '012',
                nombre: 'Tarjeta de crédito emitida en el país o en el exterior por una empresa no perteneciente al sistema financiero.'
            },
            {
                codigo: '013',
                nombre: 'Tarjetas de crédito emitidas en el exterior por empresas bancarias o financieras no domiciliadas'
            },
            {
                codigo: '101',
                nombre: 'Transferencias – Comercio exterior'
            },
            {
                codigo: '102',
                nombre: 'Cheques bancarios - Comercio exterior'
            },
            {
                codigo: '103',
                nombre: 'Orden de pago simple - Comercio exterior'
            },
            {
                codigo: '104',
                nombre: 'Orden de pago documentario - Comercio exterior'
            },
            {
                codigo: '105',
                nombre: 'Remesa simple - Comercio exterior'
            },
            {
                codigo: '106',
                nombre: 'Remesa documentaria - Comercio exterior'
            },
            {
                codigo: '107',
                nombre: 'Carta de crédito simple - Comercio exterior'
            },
            {
                codigo: '108',
                nombre: 'Carta de crédito documentario - Comercio exterior'
            },
            {
                codigo: '999',
                nombre: 'Otros medios de pago'
            }
        ],
        listaafectacion: [
            {
                id: '02',
                descripcion: 'Inafecto'
            },
            // {
            //     id: '01',
            //     descripcion: 'Gravado'
            // }
        ],
        tipoMoneda: [
            {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            {
                id: '2',
                codigo: 'EUR',
                descripcion: 'EUROS',
                simbolo: '\u20ac'
            },
            {
                id: '3',
                codigo: 'USD',
                descripcion: 'DOLARES AMERICANOS',
                simbolo: '$'
            },
            {
                id: '4',
                codigo: 'CAD',
                descripcion: 'DOLARES CANADIENSES',
                simbolo: 'C$'
            },
            {
                id: '5',
                codigo: 'GBP',
                descripcion: 'LIBRAS ESTERLINAS',
                simbolo: '\u00a3'
            },
            {
                id: '6',
                codigo: 'JPY',
                descripcion: 'YENES',
                simbolo: '\u00a5'
            },
            {
                id: '7',
                codigo: 'SEK',
                descripcion: 'CORONAS SUECAS',
                simbolo: 'kr'
            },
            {
                id: '8',
                codigo: 'CHF',
                descripcion: 'FRANCOS SUIZOS',
                simbolo: 'Fr'
            }
        ],
        EspecificacionIgv:
        [
            {
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            {
                codigo: '11',
                descripcion: 'Retiro por premio',
                codigoTributo: '9996'
            },
            {
                codigo: '12',
                descripcion: 'Retiro por donacion',
                codigoTributo: '9996'
            },
            {
                codigo: '13',
                descripcion: 'Retiro',
                codigoTributo: '9996'
            },
            {
                codigo: '14',
                descripcion: 'Retiro por publicidad',
                codigoTributo: '9996'
            },
            {
                codigo: '15',
                descripcion: 'Grabado - Bonificaciones',
                codigoTributo: '9996'
            },
            {
                codigo: '16',
                descripcion: 'Retiro por entrega a trabajadores',
                codigoTributo: '9996'
            }            
        ],
        EspecificacionIgv2:
        [
            {
				codigo: '30',
                descripcion: 'Operación Onerosa',
                codigoTributo: '9998'
			},
			{
				codigo: '31',
                descripcion: 'Retiro por Bonificación',
                codigoTributo: '9996'
			},
			{
				codigo: '32',
                descripcion: 'Retiro',
                codigoTributo: '9996'
			},
			{
				codigo: '33',
                descripcion: 'Retiro por Muestras Médicas',
                codigoTributo: '9996'
			},
			{
				codigo: '34',
                descripcion: 'Retiro por Convenio Colectivo',
                codigoTributo: '9996'
			},
			{
				codigo: '35',
                descripcion: 'Retiro por Convenio Colectivo',
                codigoTributo: '9996'
			},
			{
				codigo: '36',
                descripcion: 'Retiro por publicidad',
                codigoTributo: '9996'
			}
        ],
        itemTitleSubtotal: 'Valor Unitario',
        itemTitleTotal: 'Valor Total',
        formadepago: '008',
        tipodemoneda: {
            id: '1',
            codigo: 'PEN',
            descripcion: 'SOLES',
            simbolo: 'S/.'
        },
        valorUnitario: '',
        especificacion:{
            codigo: '10',
            descripcion: 'Operacion onerosa',
            codigoTributo: '1000'
        },
        codigoTributo:'',
        tabIndex: 0,
        itemGuia: {
            numero: '',
            tipo: ''
        },
        itemAdicional: {
            clave: '',
            valor: ''
        },
        guiasRelacionada: [],
        tiposGuia: [
                {
                    codigo: '09',
                    nombre: 'Guia Remision Remitente'
                },
                {
                    codigo: '31',
                    nombre: 'Guia Remision Transportista'
                }
        ],  
        seriedeguia: '',
        numerodeguia: '',
        tipodeguia: '09',
        tipodeguiadescripcion: '',
        selected: 1,
        options: [
            { value: 1, text: 'Factura Comercial' },
            { value: 2, text: 'Factura Contingencia' }
        ],
        ordenCompra: '',
        typeInvoice: 1,
        checkvalorunitario: false,
        codigoProducto: '',
        checkcantidad: false,
        responsecheckcantidad: '',
        checkcodigo: false,
        responsecheckcodigo: '',
        checkdescripcion: false,
        responsecheckdescripcion: '',
        checkserie: false,
        serie_valida: '',
        responsecheckserie: '',
        checkseriecon: false,
        responsecheckseriecon: '',
        checkprecioventaunitario: false,
        util: '',
        numero: '',
        name: '',
        currentdate: '',
        diasnopermitidos: {
            ranges: []
        },
        unoDieciocho:1.18,
        ceroDieciocho:0.18,
        dieciocho:18,
        // unoUno:1.1,
        // ceroUno:0.1,
        // diez:10,
        unoUno:1.105,
        ceroUno:0.105,
        diez:10.5,
        igvGlobal:null,
        }
    },
    mounted () {
        this.listInvoice(),
        this.initIgv(),
        this.initDates(),
        this.calcItem(),
        this.getSeries(),
        // this.checkTabsSeries(),
        this.showAccountDetraction()
    },
    computed: {
        unidades () {
            return this.$store.state.UnidadMedida
        },
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0){

            } else if (!expreg.test(this.serie)) {
                return false
            } else if(this.serie.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
            return this.state === true ? 'Perfecto' : ''
        },
        stateSerieGuia () {
            let expreg = new RegExp("^[A-Z0-9]{4}$")
            let numeros = new RegExp("^[0-9]$")
            let arrayserie = this.seriedeguia.split('')
            if(arrayserie[0] == 'T' || numeros.test(arrayserie[0])){
                if (this.seriedeguia.length == 0){

                } else if (!expreg.test(this.seriedeguia)) {
                    return false
                } else if(this.seriedeguia.length == 4 ){
                    return true
                }
            }else{
                return false
            }  
        },
        invalidFeedbackSerieGuia () {
            let expreg = new RegExp("^[A-Z0-9]{4}$")
            if (this.seriedeguia.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 4 caracteres'
            }
        },
        validFeedbackSerieGuia () {
            return this.stateSerieGuia === true ? 'Perfecto' : ''
        },
        stateOrdenCompra () {
            let expreg = new RegExp("^[A-Z0-9]{1,20}$")
            if (this.ordenCompra.length == 0){

            } else if (!expreg.test(this.ordenCompra)) {
                return false
            } else if(this.ordenCompra.length < 20 ){
                return true
            }
        },
        invalidFeedbackOrdenCompra () {
            let expreg = new RegExp("^[A-Z0-9]{1,20}$")
            if (this.ordenCompra.length == 0) {
                return 'Ingresa una Orden de Compra'
            } else {
                return 'Caracter Invalido'
            }
        },
        validFeedbackOrdenCompra () {
            return this.stateOrdenCompra === true ? 'OC Valida' : ''
        }
    },
    watch: {
        distritoSeleccionadoUbigeoOrigen: function () {
            this.distOrigenCargando = false,
            this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
            this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
            this.modalUbigeoPartida = false

        },
        provinciaSeleccionadaUbigeoOrigen: function () {
            this.distOrigen = true,
            this.distOrigenCargando = true,
            this.searchDistrictOrigen(this.distOrigenCargando)
        },
        departamentoSeleccionadoUbigeoOrigen: function () {
            this.provOrigen = true,
            this.searchProvinceOrigen()
        },
        distritoSeleccionadoUbigeoDestino: function () {
            this.distDestinoCargando = false,
            this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
            this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre,
            this.modalUbigeoDestino = false
            
        },
        provinciaSeleccionadaUbigeoDestino: function () {
            this.distDestino = true,
            this.distDestinoCargando = true,
            this.searchDistrictDestino(this.distDestinoCargando)
        },
        departamentoSeleccionadoUbigeoDestino: function () {
            this.provDestino = true,
            this.searchProvinceDestino()
        },
        seriecon: function () {
            if(this.seriecon.length != '' && this.serie.length != 4){
                this.checkseriecon = true
                this.responsecheckseriecon = 'Requerido 4 caracteres'
            }else{
                this.checkseriecon = false
                this.responsecheckseriecon = ''
            }
        },
        cantidad: function () {
            if(this.cantidad < 0){
                this.checkcantidad = true
                this.responsecheckcantidad = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkcantidad = false
                this.responsecheckcantidad = ''
            }         
        },
        codigoProducto: function () {
            if(this.codigoProducto.length == 30){
                this.checkcodigo = true
                this.responsecheckcodigo = 'Alfanumerico de 1 a 30 caracteres '
            }else{
                this.checkcodigo = false
                this.responsecheckcodigo = ''
            }
        },
        descripcion: function () {
            if(this.descripcion.length > 500){
                this.checkdescripcion = true
                this.responsecheckdescripcion = 'Alfanumerico de maximo 500 caracteres '
            }else{
                this.checkdescripcion = false
                this.responsecheckdescripcion = ''
            }
        },
        especificacionIgv: function () {  
            this.calcItem();
        },
        precioVentaUnitario: function () {
            if(this.precioVentaUnitario < 0){
                this.checkprecioventaunitario = true
                this.responsecheckprecioventaunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkprecioventaunitario = false
                this.responsecheckprecioventaunitario = ''
            }
            if(this.especificacionIgv=='01'){
                this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else{
                this.valorUnitario = this.precioVentaUnitario
            }
        },
        valorUnitario: function () {
            if(this.valorUnitario < 0){
                this.checkvalorunitario = true
                this.responsecheckvalorunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkvalorunitario = false
                this.responsecheckvalorunitario = ''
            }
            if(this.vunitario)
            {
                if(this.especificacionIgv=='01'){
                    this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                }
                else if(this.especificacionIgv=='02') {
                    this.precioVentaUnitario = this.valorUnitario
                }
            }
            
        },
        tipodemoneda: function () {
            this.moneda = this.tipodemoneda
        },
        ventaGratuita: function (val) {
            //if(!this.ventaGratuita){
            //      this.item.tipoPrecioVentaUnitario = '01'
            //}else{
            //        this.item.tipoPrecioVentaUnitario = '02'
            //}   
        },        
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        }
    },
    methods: {
        checkTabsSeries: function () {
            if(this.tabIndex == 6){
                this.getSeries()
            }
        },
        showAccountDetraction: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'cuenta/detraccion/buscarcuenta',{
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.cuentaDetracionAdmin = response.data.response
            ))
            .catch(error => {})
        },
        getSeries: function () {
            this.seriesCargadas = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.tipodoc, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data, 
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false,
                this.igvGlobal = response.data.igv
                ))
            .catch(error => {})
        },
        searchDepartmentOrigen: function () {
            axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listDepartmentOrigen = response.data                       
                ))
                .catch(error => {})
        },
        searchProvinceOrigen: function () {
                this.provOrigenCargando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoOrigen
                })
                .then(response => (
                    this.provOrigenCargando = false,
                    this.listProvinceOrigen = response.data                       
                ))
                .catch(error => {})
        },
        searchDistrictOrigen: function (value) {
                this.distOrigenCargando = value   
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoOrigen,
                    province: this.provinciaSeleccionadaUbigeoOrigen
                })
                .then(response => (
                    this.listDistrictOrigen = response.data,
                    this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
                    this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
                    this.distOrigenCargando = false
                ))
                .catch(error => {})
        },
        searchDepartmentDestino: function () {
            axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listDepartmentDestino = response.data                       
                ))
                .catch(error => {})
        },
        searchProvinceDestino: function () {
                this.provDestinoCargando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoDestino
                })
                .then(response => (
                    this.listProvinceDestino = response.data,
                    this.provDestinoCargando = false                       
                ))
                .catch(error => {})
        },
        searchDistrictDestino: function (value) {
                this.distDestinoCargando = value  
                axios
                .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
                    token: this.$store.getters.userToken,
                    department: this.departamentoSeleccionadoUbigeoDestino,
                    province: this.provinciaSeleccionadaUbigeoDestino
                })
                .then(response => (
                    this.listDistrictDestino = response.data,
                    this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
                    this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre,
                    this.distDestinoCargando = false  
                ))
                .catch(error => {})
        },
        enableFieldsReceptor: function () {
            this.habilitado = false
        },
        setReceiver: function (item) {
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccionReferencia = item.direccionReferencia
            this.listarec = false
        },
        setReceiverViajante: function (item) {
            this.numeroDocumentoPasajero = item.idReceptor,
            this.nombresApellidosPasajero = item.razonSocial,
            this.listarecViajante = false
        },
        initIgv: function () {
            if(this.especificacionIgv === '01'){
                this.Especificacion = this.EspecificacionIgv
            }
            else if(this.especificacionIgv === '02'){
                this.Especificacion = this.EspecificacionIgv2
            }
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(4,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
        calcItem: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                    codigo: '10',
                    descripcion: 'Operacion onerosa',
                    codigoTributo: '1000'
                }
                parent.valorUnitario = parseFloat(parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(4) //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv2
                    parent.especificacion = {                
                                codigo: '30',
                                descripcion: 'Operación Onerosa',
                                codigoTributo: '9998'		
                            }      
                    parent.valorUnitario = parent.precioVentaUnitario
                
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                    parent.Especificacion = parent.EspecificacionIgv2
                    parent.especificacion = {                
                                codigo: '30',
                                descripcion: 'Operación Onerosa',
                                codigoTributo: '9998'		
                            }      
                    parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                    parent.precioVentaUnitario = parent.valorUnitario
            }

        },
        validateFields: function () {
            if(this.descripcion!='' && this.precioVentaUnitario!==''){
                return true
            }else{
                return false
            }
        },
        validateFieldsGuia: function () {
            if(this.seriedeguia!='' && this.numerodeguia!='' && this.tipodeguia!==''){
                return true
            }else{
                return false
            }
        },
        validateFieldsAdicionales: function () {
            if(this.clave!='' && this.valor!=''){
                return true
            }else{
                return false
            }
        },
        validateInvoice: function () {
            let tiposerie = ''
            if(this.typeInvoice == 1){
                if(this.indexSerie == 0){
                    this.serie = this.listaSeries[0]
                    tiposerie = this.serie
                }else{
                    this.serie = this.listaSeries[this.indexSerie]
                    tiposerie = this.serie
                }
            }else if(this.typeInvoice == 2){
                tiposerie = this.seriecon
            }
            if(this.receptor.idReceptor!=='' && tiposerie!==''  && this.items.length>0 && !this.seriesCargadas){
                return true
            }
            else{
                return false
            }
        },
        accumulateIgv: function () {
            let val = 0.00;
                this.items.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val
            return val
        },
        accumulateTaxes: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = val
        },
        accumulateRecordedSale: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    if(element.montoAfectacionIgv !== 0){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaGravada = val
            return val
        },
        accumulateExoneratedSale: function () {
            var val = 0.00;
            this.totalVentaExonerada = 0
            return val
        },
        accumulateUnaffectedSale: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    if(element.montoAfectacionIgv == 0){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaInafecta = val
            return val
        },
        accumulateTotalSale: function () {
            var val = 0.00;
            this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta
            return this.importeTotal
        },
        setInvoice: function (data) {
            this.invoice = data
        },
        sendMail: function (data) {
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'facturas/mail', {
                token: this.$store.getters.userToken,
                id: data.idFactura,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.success(response.data.message, 'Exito')           
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        downloadXml: function (data){
            let name = data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/zip;base64,'+ data.xml           
            download(file, name,'application/zip');
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idFactura
           })
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){
               
           })      
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idFactura
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.base64,
               this.cargandopdf = false,               
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })            
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'facturas/constancia',{
               token: this.$store.getters.userToken,
               id: data.idFactura
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,               
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })    
        },
        addItem: function () {
            let item = {
                adicional: {}
            }
            let pasajero = {}
            // Si es inafecta esto es cero
            item.baseAfectacionIgv = parseFloat(this.valorUnitario*this.cantidad),
            item.valorVenta = this.valorUnitario*this.cantidad,
            item.tipoAfectacionIgv = this.especificacion.codigo,
            item.montoTotalImpuestosItem = parseFloat(0), 
            item.codigoTributo = this.especificacion.codigoTributo,
            item.unidadMedidaCantidad = 'ZZ',
            item.cantidad = parseFloat(this.cantidad),
            item.descripcion = this.descripcion,
            item.valorUnitario = parseFloat(this.valorUnitario) 

            if(this.especificacion.codigo == '10' || this.especificacion.codigo == '20' || this.especificacion.codigo == '30'){
                item.tipoPrecioVentaUnitario = '01'
            }
            else{
                item.tipoPrecioVentaUnitario = '02'
            }
            if(this.especificacionIgv == '01'){
                item.montoAfectacionIgv = parseFloat(item.cantidad*valorUnitario*(this.$store.state.igv == 18 ? 0.18 : 0.105))  //0.18
            }
            else{
                item.montoAfectacionIgv = parseFloat(0.00) 
            }
            item.porcentajeImpuesto = parseInt(0),
            item.precioVentaUnitario = parseFloat(this.precioVentaUnitario), 
            item.valorVenta = parseFloat(this.valorUnitario*this.cantidad),
            pasajero.numeroAsiento = this.numeroAsiento,
            pasajero.informacionManifiesto = this.informacionManifiesto,
            pasajero.numeroDocumentoPasajero = this.numeroDocumentoPasajero,
            pasajero.tipoDocumentoPasajero = this.tipoDocumentoPasajero,
            pasajero.nombresApellidosPasajero = this.nombresApellidosPasajero,
            pasajero.ubigeoLugarOrigen = this.ubigeoPartida,
            pasajero.ubigeoLugarDestino = this.ubigeoLlegada,
            pasajero.direccionDetalladaOrigen = this.direccionPartida,
            pasajero.direccionDetalladaDestino = this.direccionLlegada,
            pasajero.fechaInicioProgramado = this.$moment(this.fechaInicioProgramado).format('YYYY-MM-DD'),
            pasajero.horaInicioProgramado = this.$moment(this.horaInicioProgramado).format('HH:MM:ss'),
            item.codigoProductoSunat = '78111800',  //78110000
            item.idProducto = '-'      
            item.adicional.transporteTerrestrePasajeros = pasajero, 
            this.items.push(item),
            this.cantidad = '1',
            this.codigoProducto = '',
            this.descripcion = 'Pasaje',
            this.precioVentaUnitario = '',
            this.valorUnitario = '',
            this.numeroAsiento = '',
            this.informacionManifiesto = '',
            this.numeroDocumentoPasajero = '',
            this.tipoDocumentoPasajero = 1,
            this.nombresApellidosPasajero = '',
            this.ubigeoLugarOrigen = '',
            this.ubigeoLugarDestino = '',
            this.direccionDetalladaDestino = '',
            this.direccionDetalladaOrigen = '',
            this.fechaInicioProgramado = '',
            this.horaInicioProgramado = ''

        },       
         deleteItem: function (index) {
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.items.splice(index,1)
                    //this.item = {}
                }else{

                }
            })
        },
        addGuia: function () {
            let guias = {}
            guias.serie = this.seriedeguia,
            guias.numero = this.numerodeguia
            if(this.tipodeguia == '09'){
                guias.tipodeguiadescripcion = 'Guia de Remision Remitente'
            }
            else if(this.tipodeguia == '31'){
                guias.tipodeguiadescripcion = 'Guia de Remision Transportista'
            }
            guias.tipo = this.tipodeguia, 
            this.itemGuia.numero = this.seriedeguia + '-' + this.numerodeguia
            this.itemGuia.tipo = this.tipodeguia 
            this.items_guias.push(guias)
            this.guiasRelacionada.push(this.itemGuia)
            this.itemGuia = {}
            this.seriedeguia = ''
            this.numerodeguia = ''
            this.tipodeguia = '09'
        },
        deleteGuia: function (value) {
            this.items_guias.splice(value,1)
            this.guiasRelacionada.splice(value,1)
            this.seriedeguia = ''
            this.numerodeguia = ''
            this.tipodeguia = '09'
        },  
        addAdicional: function () {
           this.itemAdicional.clave = this.clave
           this.itemAdicional.valor = this.valor
           this.items_adicionales.push(this.itemAdicional) 
           this.itemAdicional = {}
           this.clave = ''
           this.valor = ''
        },
        deleteAdicional: function (value) {
            this.items_adicionales.splice(value,1)
        },  
        backItem: function (item) {
            this.add_update_item = false
            //this.item = item
        },
        updateItem: function (index) {
            this.add_update_item = true,
            //Object.assign(this.items[index], this.item)
            this.item = {},
            this.$swal('Updated', 'Cambiando datos', 'warning')
        },
        insertarAdicionales: function (event) {
            let item = {    
                nombre: this.adicionales.nombre,
                valor: this.adicionales.valor     
            }
            this.adicionales.push(item)
            this.adicionales.nombre = '',
            this.adicionales.valor = ''
        },
        listInvoice: function () {
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'facturas', {
                token: this.$store.getters.userToken,
                page: this.pactual,
                limit: this.limite,
                order: this.orden

            })
            .then(response => (
                this.invoices = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false
                ))
            .catch(error => {})
        },
        sendInvoice: function () {
            this.cargandoemision = true
            this.invoice.token = this.$store.getters.userToken
            this.invoice.receptor.nro = this.receptor.numero.toString()
            if(this.typeInvoice == 1){
                if(this.indexSerie == 0){
                    this.invoice.serie = this.listaSeries[0]
                }else{
                    this.invoice.serie = this.listaSeries[this.indexSerie]
                }
            }else{
                this.invoice.serie = this.seriecon
                this.invoice.numero = this.numero
            }       
            this.invoice.montoTotalImpuestos = this.montoTotalImpuestos*this.item.cantidad,
            this.invoice.totalVentaGravada = this.totalVentaGravada,
            this.invoice.sumatoriaIgv = this.sumatoriaIgv,
            this.invoice.totalVentaExonerada = this.totalVentaExonerada,
            this.invoice.totalVentaInafecta = this.totalVentaInafecta,
            this.invoice.importeTotal = this.importeTotal,
            this.invoice.guiasRelacionada = this.guiasRelacionada
            if(this.femision != ''){
                this.invoice.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.fvencimiento != ''){
                this.invoice.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
            }
            if(this.importeTotal >= 700){
                this.invoice.adicional.detraccion.codigoSujetoDetraccion = '028',
                this.invoice.adicional.detraccion.numeroCuentaBanco = this.cuentaDetracionAdmin,
                this.invoice.adicional.detraccion.medioPago = '001',
                this.invoice.adicional.detraccion.montoDetraccion = (this.importeTotal * parseFloat(10)/100).toFixed(2), 
                this.invoice.adicional.detraccion.porcentajeDetraccion = '10.00000'
                this.invoice.tipoOperacion = this.tipoOperacion
            }else{
                delete this.invoice.adicional.detraccion
                this.invoice.tipoOperacion = '0101'
            }
            if(this.formadepago != '000'){
                this.invoice.adicional.formaPago = this.formadepago
            }
            this.invoice.adicional.tipo_igv = this.igvGlobal
            this.invoice.adicional.ordenCompra = this.ordenCompra
            this.invoice.items = this.items
            axios
            .post(process.env.VUE_APP_API_URL + 'facturas/emitir', this.invoice)
            .then(response => (
                this.info = response.data,
                this.$snotify.success(response.data.msg, 'Éxito'),
                this.changeTab(1),
                this.cargandoemision = false,
                this.tabIndex = 1,
                this.listInvoice(),
                this.cargandoemision = false,
                this.receptor.numero = '',
                this.receptor.direccionReferencia = '',
                this.receptor.razonSocial = '',
                this.serie = '',
                this.seriecon = '',
                this.tipoDocumento = 0,
                this.formadepago = '001',
                this.ordenCompra = '',
                this.items_guias = [],
                this.guiasRelacionada = [],
                this.seriedeguia = '',
                this.numerodeguia = '',
                this.tipodeguia = '09',
                this.items_adicionales = [],
                this.clave = '',
                this.valor = '',
                this.typeInvoice = 1,
                this.items = [],
                this.ubigeoPartida = '',
                this.ubigeoLlegada = '',
                this.direccionPartida = '',
                this.direccionLlegada = '',
                this.tipoOperacion = '1003'
                ))
            .catch(error => (
                this.cargandoemision = false,
                this.catchError(error.response.data)
            ))
        },
        catchError: function (value) {
            let errorgateway = ''
            let errormessage = ''
            let errordescription = ''
            value.msg ? errorgateway = value.msg: errorgateway = ''
            value.response.message ? errormessage = value.response.message: errormessage = ''
            value.response.description ? errordescription = value.response.message: errordescription = ''
            this.$snotify.error(errordescription + ' - ' + errormessage + ' - ' + errorgateway, 'Error')
        },
        getReceivers: function (value) {
           if(value.length>3){
               this.cargandoreceptor = true
               this.listarec = true
               this.norec = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista',{
                    token: this.$store.getters.userToken,
                    q: value,
                    tipoRec: '6'
                })
                .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                })
            }            
        },
        getReceiversViajante: function (value) {
           if(value.length>3){
               this.cargandoreceptorViajante = true
               this.listarecViajante = true
               this.norecViajante = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista',{
                    token: this.$store.getters.userToken,
                    q: value,
                    tipoRec: this.tipoDocumentoPasajero
                })
                .then(response => (
                    this.listaViajantes = response.data,
                    this.cargandoreceptorViajante = false,
                    this.receivercountViajante(this.listaViajantes.length)
                ))
                .catch(function (error){
                    this.cargandoreceptorViajante = false
                })
            }            
        },
        receivercount: function (value){
            if(!value)
            {
                this.norec = true
            }
            else
            {
                this.norec = false
            }
        },
        receivercountViajante: function (value){
            if(!value)
            {
                this.norec = true
            }
            else
            {
                this.norec = false
            }
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        }
    }
}
</script>

<style scoped>
  .facturador{
      padding-left: 20px;
      padding-right: 20px;
  }
  .botones{
      margin-top: 30px;
  }
  #info_item{
      margin-right: 15px;
  }
  .inputpersonalizado{
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
  }
  .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1)
}

.dropdown li:last-child {
  border-bottom: none;
}

.dropdown li a {
  padding: 10px 20px;
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 1.25em;
}

.dropdown li a .fa {
  padding-right: 0.5em;
}
.dropdown-toggle{
    padding-bottom: 0px !important;
}
.v-select .dropdown-toggle .clear {
    font-size: 23px;
    font-weight: 700;
    line-height: 1;
    color: rgba(60,60,60,.5);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 6px;
    display: none;
}
label
{
    margin-bottom: 0 !important;
}
.input-requerido::placeholder {
    color:red;
    opacity: 0.7;
}
.searcher-field{
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 500px !important;
    border: none !important;
}
.searcher-result{
    font-size: smaller;
    padding: 2px 0px 2px 0px;
    cursor: pointer;
}
.sinresultados{
    padding: 0 5px 0 5px;  
}
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #FF9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}
.colorestelemovil{
    background-color: #006eae;
    color: #ffffff;
}
</style>

